// Generated file; do not edit. See https://github.com/stencila/stencila/tree/main/rust/schema-gen

export type BlockType =
  | "Admonition"
  | "CallBlock"
  | "Claim"
  | "CodeBlock"
  | "CodeChunk"
  | "DeleteBlock"
  | "Figure"
  | "ForBlock"
  | "Form"
  | "Heading"
  | "IfBlock"
  | "IncludeBlock"
  | "InsertBlock"
  | "InstructionBlock"
  | "List"
  | "MathBlock"
  | "ModifyBlock"
  | "Paragraph"
  | "QuoteBlock"
  | "ReplaceBlock"
  | "Section"
  | "StyledBlock"
  | "Table"
  | "ThematicBreak";

export const BlockTypeList = [
  "Admonition",
  "CallBlock",
  "Claim",
  "CodeBlock",
  "CodeChunk",
  "DeleteBlock",
  "Figure",
  "ForBlock",
  "Form",
  "Heading",
  "IfBlock",
  "IncludeBlock",
  "InsertBlock",
  "InstructionBlock",
  "List",
  "MathBlock",
  "ModifyBlock",
  "Paragraph",
  "QuoteBlock",
  "ReplaceBlock",
  "Section",
  "StyledBlock",
  "Table",
  "ThematicBreak",
];
